import {useFetchRushFriendScoresQuery} from '@api';
import {RushTypes} from '@types';
import {useRushQueryParams} from '@utils';
import {RushScoreTable} from './RushScoreTable';

export const RushTabFriends = () => {
    const {rushType, filter, sort, setSort} = useRushQueryParams();

    const {
        data: friendScores,
        isFetching,
        isError,
        refetch,
    } = useFetchRushFriendScoresQuery({
        rushType: rushType ?? RushTypes.TYPE_3_MINUTES,
        filter,
        sort,
        limit: 20,
    });

    return (
        <RushScoreTable
            data={friendScores?.entries || []}
            sort={sort}
            setSort={setSort}
            isLoading={isFetching}
            isError={isError}
            onRetry={refetch}
        />
    );
};
